import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-navy-900 text-white py-16 md:py-24 px-4" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-154">
            ¿Qué incluye tu guía?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mt-6 rounded-full" data-id="element-155"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-156">
          <motion.div variants={itemVariants} className="bg-navy-800 p-6 rounded-xl border border-slate-700/50 hover:border-gold/50 transition-colors" data-id="element-157">
            <div className="flex items-start" data-id="element-158">
              <CheckIcon className="w-6 h-6 text-green-500 mr-4 shrink-0 mt-1" data-id="element-159" />
              <div data-id="element-160">
                <h3 className="text-xl font-bold text-gold mb-2" data-id="element-161">
                  La Guía Maestra PDF
                </h3>
                <p className="text-slate-300" data-id="element-162">
                  Paso a paso desde la idea hasta el primer dólar.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-navy-800 p-6 rounded-xl border border-slate-700/50 hover:border-gold/50 transition-colors" data-id="element-163">
            <div className="flex items-start" data-id="element-164">
              <CheckIcon className="w-6 h-6 text-green-500 mr-4 shrink-0 mt-1" data-id="element-165" />
              <div data-id="element-166">
                <h3 className="text-xl font-bold text-gold mb-2" data-id="element-167">
                  El Filtro "Gasolina"
                </h3>
                <p className="text-slate-300" data-id="element-168">
                  Cómo elegir temas que la gente compra por desesperación (no
                  por gusto).
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-navy-800 p-6 rounded-xl border border-slate-700/50 hover:border-gold/50 transition-colors" data-id="element-169">
            <div className="flex items-start" data-id="element-170">
              <CheckIcon className="w-6 h-6 text-green-500 mr-4 shrink-0 mt-1" data-id="element-171" />
              <div data-id="element-172">
                <h3 className="text-xl font-bold text-gold mb-2" data-id="element-173">
                  Shopify Express
                </h3>
                <p className="text-slate-300" data-id="element-174">
                  Tutorial para tener tu tienda lista para recibir pagos en 60
                  minutos.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-navy-800 p-6 rounded-xl border border-slate-700/50 hover:border-gold/50 transition-colors" data-id="element-175">
            <div className="flex items-start" data-id="element-176">
              <CheckIcon className="w-6 h-6 text-green-500 mr-4 shrink-0 mt-1" data-id="element-177" />
              <div data-id="element-178">
                <h3 className="text-xl font-bold text-gold mb-2" data-id="element-179">
                  Imán de Ventas en Meta
                </h3>
                <p className="text-slate-300" data-id="element-180">
                  La estrategia de anuncios de $5 al día para atraer clientes
                  sin salir en cámara.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-navy-800 p-6 rounded-xl border border-slate-700/50 hover:border-gold/50 transition-colors md:col-span-2 md:max-w-md md:mx-auto w-full" data-id="element-181">
            <div className="flex items-start" data-id="element-182">
              <CheckIcon className="w-6 h-6 text-green-500 mr-4 shrink-0 mt-1" data-id="element-183" />
              <div data-id="element-184">
                <h3 className="text-xl font-bold text-gold mb-2" data-id="element-185">
                  Ruta a los $1,000
                </h3>
                <p className="text-slate-300" data-id="element-186">
                  El plan diario para escalar tus ventas de forma constante.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}